/**
 * Resolve a live anchor for a help target_key: registry first, then `[data-help-target]` in the DOM.
 * Same resolution as the walkthrough overlay so listing and spotlighting agree.
 */
export function resolveHelpTargetElement(
  registry: { get: (targetKey: string) => HTMLElement | null },
  targetKey: string
): HTMLElement | null {
  if (!targetKey?.trim()) {
    return null;
  }
  const registered = registry.get(targetKey);
  if (registered?.isConnected) {
    return registered;
  }
  try {
    const selector =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? `[data-help-target="${CSS.escape(targetKey)}"]`
        : `[data-help-target="${targetKey.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"]`;
    const found = document.querySelector(selector);
    return found instanceof HTMLElement ? found : null;
  } catch {
    return null;
  }
}
